export enum InterviewInitiatedByType {
    Admin = 'admin',
    Email = 'email',
    Housematch = 'housematch',
}
